import { useState } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';
import AskBetaInfoModal from './AskBetaInfoModal';
import styles from './AskSidebar.module.scss';

/**
 * Legal's notice that Ask's answers come from third-party AI, with "Learn more" opening the full disclosure.
 */
const AskAiNotice = () => {
  const [isBetaInfoOpen, setIsBetaInfoOpen] = useState(false);

  const notice = 'Powered by third-party AI. Always verify accuracy before heading out.'; // hwandrew TODO: XPLR-204 translations
  const learnMoreLabel = 'Learn more'; // hwandrew TODO: XPLR-204 translations

  return (
    <div className={styles.aiNotice}>
      <Typography color="secondary" component="p" mb="0" mt="0" variant="text100">
        {notice}{' '}
        <Link onClick={() => setIsBetaInfoOpen(true)} variant="secondary">
          {learnMoreLabel}
        </Link>
      </Typography>
      <AskBetaInfoModal isOpen={isBetaInfoOpen} onClose={() => setIsBetaInfoOpen(false)} />
    </div>
  );
};

export default AskAiNotice;
